export default __webpack_public_path__ + "static/media/Zukala's Rites.ec82f5fe.jpg";